// removed by extract-text-webpack-plugin
module.exports = {"message_popup_form":"GsFNu6Yd","message_success":"_1fYgQ556","message_container":"_Hc2w0Vv","message_delete":"_3QKDFPwB","buttons_box":"hQK2wuen"};


//////////////////
// WEBPACK FOOTER
// ./src/client/website/components/Messages/InfoWarning/InfoWarning.styl
// module id = 348
// module chunks = 0